module.exports = __webpack_public_path__ + "static/media/pax-gold.6cb76b24.svg";